// Mock data extracted from axiomas.shop

export const categories = [
  {
    id: 'genti',
    name: 'Genți',
    slug: 'genti',
    count: 12,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/1.png',
  },
  {
    id: 'ceasuri',
    name: 'Ceasuri',
    slug: 'ceasuri',
    count: 3,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/2.png',
  },
  {
    id: 'ingrijire-personala',
    name: 'Îngrijire personală',
    slug: 'ingrijire-personala',
    count: 0,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/4.png',
  },
  {
    id: 'jucarii-pentru-copii',
    name: 'Jucării pentru copii',
    slug: 'jucarii-pentru-copii',
    count: 0,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/5.png',
  },
  {
    id: 'casa-si-gradina',
    name: 'Casă și grădină',
    slug: 'casa-si-gradina',
    count: 0,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/6.png',
  },
  {
    id: 'articole-pentru-bucatarie',
    name: 'Articole pentru bucătărie',
    slug: 'articole-pentru-bucatarie',
    count: 1,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/3.png',
  },
];

export const products = [
  {
    id: 11018,
    slug: 'geanta-laptop-14-inch-piele-verde-eleganta',
    name: 'Geanta business laptop 14 inch, din piele, design elegant, verde',
    price: 785,
    oldPrice: 1157,
    discount: 32,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2026/02/IMG_6978-768x1024.jpg',
    images: [
      'https://axiomas.shop/wp-content/uploads/2026/02/IMG_6978-768x1024.jpg',
    ],
    description: 'Geantă business pentru laptop de 14 inch, realizată din piele naturală de cea mai bună calitate. Design elegant, în nuanță verde, perfect pentru profesioniști care apreciază stilul și funcționalitatea.',
    sku: 'AX-11018',
    rating: 0,
  },
  {
    id: 10990,
    slug: 'rucsac-barbatesc-din-piele-naturala-2',
    name: 'Rucsac bărbătesc din piele naturală',
    price: 785,
    oldPrice: 985,
    discount: 20,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2026/01/Screenshot-2026-01-18-141527-768x856.png',
    images: [
      'https://axiomas.shop/wp-content/uploads/2026/01/Screenshot-2026-01-18-141527-768x856.png',
    ],
    description: 'Rucsac bărbătesc clasic din piele naturală premium. Spațios, durabil și extrem de elegant, ideal pentru zilele de lucru sau pentru călătorii scurte.',
    sku: 'AX-10990',
    rating: 0,
  },
  {
    id: 10986,
    slug: 'servieta-business-din-piele-naturala',
    name: 'Servietă business din piele naturală',
    price: 1585,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2026/01/Screenshot-2026-01-18-141113-768x622.png',
    images: [
      'https://axiomas.shop/wp-content/uploads/2026/01/Screenshot-2026-01-18-141113-768x622.png',
    ],
    description: 'Servietă business din piele naturală, perfectă pentru profesioniști. Compartimente generoase, finisaje impecabile și un design care impune respect.',
    sku: 'AX-10986',
    rating: 0,
  },
  {
    id: 10869,
    slug: 'rucsac-din-piele-naturala-pentru-barbati',
    name: 'Rucsac din piele naturală pentru bărbați',
    price: 785,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_eb53d593266fc9e5c058200a772684a2.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_eb53d593266fc9e5c058200a772684a2.avif',
    ],
    description: 'Rucsac premium din piele naturală pentru bărbați. Capacitate generoasă și design modern, ce combină eleganța clasică cu praticitatea zilei moderne.',
    sku: 'AX-10869',
    rating: 0,
  },
  {
    id: 10865,
    slug: 'servieta-pentru-barbati-din-piele-naturala-crazy-horse',
    name: 'Servietă pentru bărbați din piele naturală Crazy Horse',
    price: 785,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_9e455836d1249aee2985075c69e93240.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_9e455836d1249aee2985075c69e93240.avif',
    ],
    description: 'Servietă pentru bărbați din piele naturală tratată Crazy Horse. Pielea capătă un aspect vintage cu trecerea timpului, fiecare exemplar fiind unic.',
    sku: 'AX-10865',
    rating: 0,
  },
  {
    id: 10695,
    slug: 'geanta-business-barbati-piele-naturala-neagra-slim-manere-duble-30x40cm',
    name: 'Geantă business bărbați, piele naturală, neagră, slim, mânere duble, 30x40cm',
    price: 1385,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_094e36d99ea6e253e0a4f44c94aba912.jpg',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_094e36d99ea6e253e0a4f44c94aba912.jpg',
    ],
    description: 'Geantă business slim pentru bărbați, din piele naturală neagră. Mânere duble robuste și dimensiuni perfecte 30x40cm pentru documente și laptop.',
    sku: 'AX-10695',
    rating: 0,
  },
  {
    id: 10699,
    slug: 'geanta-business-piele-naturala-crocodil-culoare-maro',
    name: 'Geantă business, piele naturală crocodil, culoare maro',
    price: 1285,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_f27c0214b2fbb4b5a3ff46bbd21bfefb-623x625.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_f27c0214b2fbb4b5a3ff46bbd21bfefb-623x625.avif',
    ],
    description: 'Geantă business din piele naturală cu textură de crocodil, în nuanță maro caldă. Un accesoriu de lux pentru profesionistul exigent.',
    sku: 'AX-10699',
    rating: 0,
  },
  {
    id: 10704,
    slug: 'geanta-business-piele-naturala-crocodil-culoare-neagra',
    name: 'Geantă business, piele naturală crocodil, culoare neagră',
    price: 1285,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_765ac469c189eb5ec68ee12d09a0ab4d.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_765ac469c189eb5ec68ee12d09a0ab4d.avif',
    ],
    description: 'Geantă business din piele naturală cu textură de crocodil, în nuanță neagră elegantă. Eleganță absolută într-un design clasic și atemporal.',
    sku: 'AX-10704',
    rating: 0,
  },
  {
    id: 10685,
    slug: 'geanta-bussiness-barbati-piele-naturala-maro',
    name: 'Geantă business bărbați, piele naturală, maro',
    price: 1385,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_8dcee4317684add3cbe837b80870686c-1.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_8dcee4317684add3cbe837b80870686c-1.avif',
    ],
    description: 'Geantă business bărbătească din piele naturală maro, finisată manual. Capacitate generoasă pentru documente și laptop, design clasic și elegant.',
    sku: 'AX-10685',
    rating: 0,
  },
  {
    id: 10840,
    slug: 'rucsac-barbatesc-din-piele-naturala',
    name: 'Rucsac bărbătesc din piele naturală',
    price: 785,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/Screenshot_20251225-222201-display-10-1024x1015.png',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/Screenshot_20251225-222201-display-10-1024x1015.png',
    ],
    description: 'Rucsac bărbătesc din piele naturală premium, cu compartimente multiple. Ideal pentru drumeții urbane sau călătorii scurte.',
    sku: 'AX-10840',
    rating: 0,
  },
  {
    id: 10860,
    slug: 'rucsac-dama-din-piele-naturala',
    name: 'Rucsac damă din piele naturală',
    price: 1585,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_591f202909a7974adb139105e145b209.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_591f202909a7974adb139105e145b209.avif',
    ],
    description: 'Rucsac damă elegant din piele naturală, perfect pentru femeia modernă. Design feminin rafinat și funcționalitate impecabilă.',
    sku: 'AX-10860',
    rating: 0,
  },
  {
    id: 10856,
    slug: 'rucsac-din-piele-naturala',
    name: 'Rucsac din piele naturală',
    price: 2385,
    oldPrice: null,
    discount: 0,
    category: 'genti',
    categoryName: 'Genți',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_99cfd584fea13bf5a74907ee9a6a855c.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_99cfd584fea13bf5a74907ee9a6a855c.avif',
    ],
    description: 'Rucsac premium din piele naturală de calitate excepțională. Un produs de top pentru clienții care apreciază cele mai înalte standarde.',
    sku: 'AX-10856',
    rating: 0,
  },
  {
    id: 10836,
    slug: 'ceas-barbatesc-orient-automatic',
    name: 'Ceas bărbătesc, Orient, automatic',
    price: 2285,
    oldPrice: null,
    discount: 0,
    category: 'ceasuri',
    categoryName: 'Ceasuri',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/Screenshot-2026-01-18-142137.png',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/Screenshot-2026-01-18-142137.png',
    ],
    description: 'Ceas bărbătesc Orient cu mecanism automatic. Brand japonez de prestigiu, design clasic și fiabilitate dovedită în timp.',
    sku: 'AX-10836',
    rating: 0,
  },
  {
    id: 10837,
    slug: 'ceas-de-mana-orient-cadran-albastru',
    name: 'Ceas de mână Orient, cadran albastru, brățară inox, rezistență 5 ATM, mecanism automatic, diametru 43.5mm',
    price: 1385,
    oldPrice: null,
    discount: 0,
    category: 'ceasuri',
    categoryName: 'Ceasuri',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/Screenshot_20251225-221427-display-9-768x975.png',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/Screenshot_20251225-221427-display-9-768x975.png',
    ],
    description: 'Ceas Orient cu cadran albastru elegant, brățară din inox, rezistență 5 ATM și mecanism automatic. Diametru 43.5mm — perfect pentru bărbații cu gust.',
    sku: 'AX-10837',
    rating: 0,
  },
  {
    id: 10708,
    slug: 'ceas-seiko-lukia-automatic-de-dama',
    name: 'Ceas Seiko Lukia, automatic de damă, Made in Japan',
    price: 3485,
    oldPrice: null,
    discount: 0,
    category: 'ceasuri',
    categoryName: 'Ceasuri',
    inStock: true,
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/res_730361d1c65190222f93951cd90186ff-1.avif',
    images: [
      'https://axiomas.shop/wp-content/uploads/2025/12/res_730361d1c65190222f93951cd90186ff-1.avif',
    ],
    description: 'Ceas Seiko Lukia automatic pentru damă, fabricat în Japonia. Bijuterie de încheietură pentru femeia rafinată, design feminin de excepție.',
    sku: 'AX-10708',
    rating: 0,
  },
];

export const heroBanners = [
  {
    id: 1,
    title: 'Genți din piele naturală',
    subtitle: 'Calitate care se vede. Stil care rezistă.',
    cta: 'Vezi colecția',
    link: '/categorie/genti',
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/explore-2-scaled.png',
  },
  {
    id: 2,
    title: 'Ceasuri elegante',
    subtitle: 'Seiko Lukia, automatic',
    cta: 'Vezi colecția',
    link: '/categorie/ceasuri',
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/explore-5-scaled.png',
  },
];

export const promoCards = [
  {
    id: 1,
    title: 'Articole pentru bucătărie',
    cta: 'Vezi produse',
    image: 'https://axiomas.shop/wp-content/uploads/2025/12/explore-6-scaled.png',
    link: '/categorie/articole-pentru-bucatarie',
  },
  {
    id: 2,
    title: 'Geantă business, piele naturală crocodil',
    cta: 'Comandă acum',
    image: 'https://axiomas.shop/wp-content/uploads/2022/12/explore-scaled-580x365.png',
    link: '/categorie/genti',
  },
];

export const popularProducts = products.slice(0, 4);
export const hotDeals = products.filter((p) => p.discount > 0).concat(products.slice(5, 8));
export const newArrivals = products.slice(0, 12);
